import * as React from "react";

// SOF-816: display-only informational label showing the IRS maximum
// contribution amount for a flexible benefit. Renders nothing when no limit is
// configured. Amounts are shown as whole US dollars (e.g. "$4,500"). This label
// never binds to or validates the contribution input fields.
const wholeDollars = (amount) =>
  `$${Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;

const FlexContributionLimitLabel = ({ label, amount }) => {
  if (amount === null || amount === undefined || amount === "") {
    return null;
  }

  return (
    <span
      role="note"
      aria-label={`${label} maximum contribution ${wholeDollars(amount)}`}
      style={{
        display: "inline-block",
        backgroundColor: "#eef4fb",
        color: "#1f3b57",
        border: "1px solid #cfe0f2",
        borderRadius: "12px",
        padding: "2px 10px",
        marginRight: "8px",
        marginTop: "4px",
        fontSize: "13px",
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {label} - Max Contribution: {wholeDollars(amount)}
    </span>
  );
};

export default FlexContributionLimitLabel;
